module.exports = __webpack_public_path__ + "static/img/interpretive-illustration.da0053d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/creative-services/interpretive-illustration.jpg
// module id = 420
// module chunks = 0